import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {POST_BLACKLISTED_CANDIDATE_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostBlacklistedCandidateRequest {
  name: string;
  userIdType: string;
  dateOfBirth: string;
  examType: string;
  uinfin?: string;
  passport?: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void, reqData: PostBlacklistedCandidateRequest) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostBlacklistedCandidate = ({onSuccess, onError}: Input = {}) => {
  const postBlacklistedCandidate = async (reqBody: PostBlacklistedCandidateRequest) => {
    await axiosClient.post(POST_BLACKLISTED_CANDIDATE_URL, reqBody);
  };

  return useCustomMutation(postBlacklistedCandidate, {
    onSuccess,
    onError,
  });
};
